import { createSpkStatementQuickBooksVendor } from '../../../graphql/custom_mutations';
import PropTypes from 'prop-types';
import { generateClient } from "aws-amplify/api";
const client = generateClient();

export const createQBVendor = async (props) => {
  if (!props) return;
  console.log('createQBVendor props: ', props);
  try {
    const gqlParams = { input: props };
    console.log('gqlParams: ', gqlParams);
    const response = await client.graphql({
      query: createSpkStatementQuickBooksVendor,
      variables: gqlParams
    });
    console.log('createQBVendor response: ', response);
    const results = response.data.createSpkStatementQuickBooksVendorTbl.qbId;
    console.log('createQBVendor results: ', results);
    return results;
  } catch (err) {
    return ('error createQBVendor: ', [err]);
  }
};

createQBVendor.propTypes = {
  props: PropTypes.object.isRequired,
};